(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apeiros-bench-cart"]) return;
  try {
    
(function(){
  function init(){
    var el=document.getElementById('ap-bench-cart-data'); if(!el||el.dataset.w) return;
    var act=document.querySelector('.ap-bench__actions'); var trio=document.querySelector('.ap-bench__trio-cta');
    if(!act&&!trio) return; el.dataset.w=1;
    var data=JSON.parse(el.textContent);
    function idx(role){var a=document.querySelector('[data-role="'+role+'"].is-active');return a?+a.dataset.idx:(role==='anchor'?0:1);}
    function add(items){
      items=items.filter(function(i){return i.id;});
      if(!items.length) return;
      var cart=document.querySelector('cart-drawer');
      var body={items:items};
      if(cart&&cart.getSectionsToRender){body.sections=cart.getSectionsToRender().map(function(s){return s.id;});body.sections_url=window.location.pathname;}
      fetch((window.routes&&window.routes.cart_add_url)||'/cart/add',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json();})
      .then(function(res){
        if(res&&res.status){window.location=(window.routes&&window.routes.cart_url)||'/cart';return;}
        if(cart&&cart.renderContents){if(cart.classList.contains('is-empty'))cart.classList.remove('is-empty');cart.renderContents(res);}
        else{window.location=(window.routes&&window.routes.cart_url)||'/cart';}
      }).catch(function(){window.location=(window.routes&&window.routes.cart_url)||'/cart';});
    }
    if(act){
      var both=act.querySelector('.ap-btn'); var vials=act.querySelector('.ap-btn--ghost');
      if(both)both.addEventListener('click',function(e){e.preventDefault();var a=idx('anchor'),v=idx('veil');var pair=[a,v].sort().join(',');if(pair==='0,1'&&data.garden){add([{id:data.garden,quantity:1}]);}else{add([{id:data.bottles[a],quantity:1},{id:data.bottles[v],quantity:1}]);}});
      if(vials)vials.addEventListener('click',function(e){e.preventDefault();add([{id:data.samples[idx('anchor')],quantity:1},{id:data.samples[idx('veil')],quantity:1}]);});
    }
    if(trio)trio.addEventListener('click',function(e){e.preventDefault();add([{id:data.samples[0],quantity:1},{id:data.samples[1],quantity:1},{id:data.samples[2],quantity:1}]);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apeiros-header"]) return;
  try {
    
  document.querySelectorAll('[data-ap-burger]').forEach(function(b){if(b.dataset.w)return;b.dataset.w=1;b.addEventListener('click',function(){var h=b.closest('[data-ap-header]'),m=h&&h.querySelector('[data-ap-mobile]');if(!m)return;var o=m.classList.toggle('is-open');m.hidden=!o;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apeiros-layering-bench"] && !Shopify.designMode) return;
  try {
    
    (function () {
      document.querySelectorAll('[id^="ap-bench-"]').forEach(function (root) {
        var bench = root.querySelector('[data-bench]');
        var dataEl = root.querySelector('[data-bench-combos]');
        if (!bench || !dataEl || bench.dataset.wired) return;
        bench.dataset.wired = '1';
        var combos = JSON.parse(dataEl.textContent);
        var state = { anchor: 0, veil: 1 };
        var panel = root.querySelector('.ap-bench__panel');
        var els = {
          name: root.querySelector('[data-combo-name]'),
          ratio: root.querySelector('[data-combo-ratio]'),
          body: root.querySelector('[data-combo-body]'),
          stack: root.querySelector('[data-combo-stack]'),
          when: root.querySelector('[data-combo-when]'),
          sillage: root.querySelector('[data-combo-sillage]')
        };
        function render() {
          var c = combos[state.anchor + '|' + state.veil];
          if (!c) return;
          els.name.textContent = c.name;
          els.ratio.textContent = c.ratio;
          els.body.textContent = c.body;
          els.when.textContent = c.when;
          els.sillage.textContent = c.sillage;
          els.stack.innerHTML = c.stack.map(function (s) {
            return '<div class="ap-bench__stack-row"><div class="ap-bench__stack-label">' + s[0] +
              '</div><div class="ap-bench__bar" style="max-width:' + s[1] + '%"></div></div>';
          }).join('');
          root.querySelectorAll('[data-role="anchor"]').forEach(function (b) { b.classList.toggle('is-active', +b.dataset.idx === state.anchor); });
          root.querySelectorAll('[data-role="veil"]').forEach(function (b) { b.classList.toggle('is-active', +b.dataset.idx === state.veil); });
        }
        root.querySelectorAll('[data-role]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            state[btn.dataset.role] = +btn.dataset.idx;
            render();
          });
        });
        render();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apeiros-quiz"] && !Shopify.designMode) return;
  try {
    
    (function () {
      document.querySelectorAll('[id^="ap-quiz-"]').forEach(function (root) {
        var wrap = root.querySelector('[data-quiz]');
        if (!wrap || wrap.dataset.wired) return;
        wrap.dataset.wired = '1';
        var QUIZ = JSON.parse(root.querySelector('[data-quiz-questions]').textContent);
        var RESULTS = JSON.parse(root.querySelector('[data-quiz-results]').textContent);
        var SCENTS = JSON.parse(root.querySelector('[data-quiz-scents]').textContent);
        var dots = root.querySelector('[data-quiz-dots]');
        var view = root.querySelector('[data-quiz-view]');
        var state = { step: 0, ans: [] };

        function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;'); }

        function renderDots() {
          var asking = state.step < QUIZ.length;
          dots.innerHTML = QUIZ.map(function (_, k) {
            var cls = 'ap-quiz__dot';
            if (k === state.step && asking) cls += ' is-cur';
            else if (k <= state.step || !asking) cls += ' is-done';
            return '<span class="' + cls + '"></span>';
          }).join('');
        }

        function renderQuestion() {
          root.classList.remove('ap-quiz--done');
          var q = QUIZ[state.step];
          var opts = q.opts.map(function (o, k) {
            return '<div class="ap-quiz__opt" data-pick="' + k + '"><div class="ap-quiz__opt-l">' + esc(o.label) +
              '</div><p class="ap-quiz__opt-b">' + esc(o.body) + '</p></div>';
          }).join('');
          view.innerHTML =
            '<div class="ap-quiz__ask"><div class="ap-quiz__step">Question ' + (state.step + 1) + ' of ' + QUIZ.length + '</div>' +
            '<h1 class="ap-quiz__q">' + esc(q.q) + '</h1><p class="ap-quiz__hint">' + esc(q.hint) + '</p>' +
            '<div class="ap-quiz__opts">' + opts + '</div>' +
            (state.step > 0 ? '<button class="ap-quiz__back" data-back>Back</button>' : '') + '</div>';
          view.querySelectorAll('[data-pick]').forEach(function (el) {
            el.addEventListener('click', function () {
              state.ans = state.ans.slice(0, state.step).concat(+el.dataset.pick);
              state.step += 1;
              render();
            });
          });
          var back = view.querySelector('[data-back]');
          if (back) back.addEventListener('click', function () { state.step = Math.max(0, state.step - 1); render(); });
        }

        function winner() {
          var tally = { adam: 0, eve: 0, epiphany: 0 };
          state.ans.forEach(function (ai, qi) {
            var s = QUIZ[qi].opts[ai].s;
            Object.keys(s).forEach(function (k) { tally[k] += s[k]; });
          });
          return Object.keys(tally).sort(function (a, b) { return tally[b] - tally[a]; })[0];
        }

        function renderResult() {
          root.classList.add('ap-quiz--done');
          var key = winner();
          var r = RESULTS[key];
          var sc = SCENTS[key] || {};
          var price = sc.price || '$69.99';
          view.innerHTML =
            '<div class="ap-quiz__result">' +
              '<div class="ap-quiz__result-media"><span class="ap-quiz__ring ap-quiz__ring--1"></span><span class="ap-quiz__ring ap-quiz__ring--2"></span>' +
                (sc.img ? '<img class="ap-quiz__result-img" src="' + sc.img + '" alt="' + esc(r.name) + '">' : '') + '</div>' +
              '<div><div class="ap-quiz__r-eyebrow">Your fragrance</div>' +
                '<h1 class="ap-quiz__r-name">' + esc(r.name) + '</h1>' +
                '<div class="ap-quiz__r-verse-wrap"><div class="ap-quiz__r-verse">' + esc(r.verse) + '</div><div class="ap-quiz__r-ref">' + esc(r.ref) + '</div></div>' +
                '<p class="ap-quiz__r-body">' + esc(r.body) + '</p>' +
                '<div class="ap-quiz__r-notes">' + esc(r.notes) + '</div>' +
                '<div class="ap-quiz__r-actions">' +
                  '<a class="ap-btn" data-foil="1" href="' + (sc.url || '#') + '">Add ' + esc(r.name) + ' · ' + price + '</a>' +
                  '<a class="ap-btn--ghost" data-ghost="1" href="' + (sc.url || '#') + '">Try 5ml · $14.99</a>' +
                '</div>' +
                '<div class="ap-quiz__r-foot"><button class="ap-quiz__restart" data-restart>Start over</button>' +
                  '<span class="ap-quiz__r-credit">The $14.99 comes back as credit.</span></div>' +
              '</div>' +
            '</div>';
          var rs = view.querySelector('[data-restart]');
          if (rs) rs.addEventListener('click', function () { state = { step: 0, ans: [] }; render(); });
        }

        function render() {
          renderDots();
          if (state.step < QUIZ.length) renderQuestion(); else renderResult();
        }
        render();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apeiros-seasons"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var wide = window.matchMedia('(min-width: 750px)');
  var els = [];
  function collect() { els = [].slice.call(document.querySelectorAll('.ap-season[data-parallax] [data-parallax-el]')); }
  var ticking = false;
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    if (!wide.matches) { els.forEach(function (el) { el.style.transform = ''; }); return; }
    els.forEach(function (el) {
      var s = el.closest('.ap-season'); var r = s.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var prog = (r.top + r.height / 2 - vh / 2) / vh;         /* -1 .. 1 */
      var y = Math.max(-22, Math.min(22, -prog * 22));
      el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    });
  }
  function boot() { collect(); update(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { collect(); update(); }, { passive: true });
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
